import { SVGProps } from "react";

export function WhatsApp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_181_23378)">
        <path
          d="M0.341291 8.50422C0.340916 9.85903 0.694916 11.1819 1.36804 12.3479L0.276917 16.3318L4.35392 15.2628C5.48157 15.8766 6.74501 16.1983 8.02892 16.1984H8.03229C12.2707 16.1984 15.7209 12.7495 15.7227 8.51028C15.7235 6.45609 14.9243 4.52447 13.4722 3.07122C12.0203 1.61809 10.0894 0.817405 8.03198 0.816467C3.79304 0.816467 0.343104 4.26522 0.341354 8.50422"
          fill="url(#paint0_linear_181_23378)"
        />
        <path
          d="M0.066402 8.50165C0.0659645 9.90521 0.432652 11.2754 1.12978 12.4831L-0.000473022 16.6098L4.22271 15.5025C5.38634 16.137 6.69646 16.4715 8.02959 16.472H8.03303C12.4235 16.472 15.9977 12.899 15.9995 8.50802C16.0003 6.38002 15.1723 4.37896 13.6683 2.87365C12.1641 1.36852 10.1641 0.539022 8.03303 0.538147C3.64178 0.538147 0.068152 4.11065 0.066402 8.50165ZM2.58146 12.2751L2.42378 12.0248C1.7609 10.9708 1.41103 9.75283 1.41153 8.50215C1.4129 4.85246 4.38315 1.88315 8.03553 1.88315C9.80428 1.8839 11.4665 2.5734 12.7168 3.8244C13.967 5.07552 14.6549 6.73865 14.6545 8.50752C14.6528 12.1572 11.6825 15.1269 8.03303 15.1269H8.0304C6.84209 15.1263 5.67665 14.8071 4.66028 14.2041L4.4184 14.0606L1.91228 14.7177L2.58146 12.2751Z"
          fill="url(#paint1_linear_181_23378)"
        />
        <path
          d="M6.04212 5.17254C5.89299 4.84111 5.73606 4.83442 5.59424 4.82861C5.47812 4.82361 5.34537 4.82398 5.21274 4.82398C5.07999 4.82398 4.86431 4.87392 4.68199 5.07298C4.49949 5.27223 3.98524 5.75373 3.98524 6.73304C3.98524 7.71236 4.69856 8.65886 4.79799 8.79179C4.89756 8.92448 6.17506 10.9985 8.19831 11.7964C9.87981 12.4594 10.222 12.3275 10.5869 12.2943C10.9519 12.2612 11.7647 11.8129 11.9305 11.3481C12.0964 10.8834 12.0964 10.485 12.0467 10.4017C11.9969 10.3188 11.8642 10.269 11.6651 10.1695C11.4661 10.07 10.4874 9.58836 10.3049 9.52192C10.1224 9.45554 9.98974 9.42242 9.85699 9.62173C9.72424 9.82073 9.34306 10.269 9.22687 10.4017C9.11081 10.5348 8.99462 10.5514 8.79562 10.4518C8.59643 10.3519 7.95537 10.142 7.19481 9.46392C6.60306 8.93629 6.20356 8.28473 6.08743 8.08542C5.97131 7.88642 6.07499 7.77854 6.17481 7.67936C6.26424 7.59017 6.37393 7.44692 6.47356 7.33073C6.57281 7.21448 6.60593 7.13154 6.67231 6.99879C6.73874 6.86592 6.70549 6.74967 6.65581 6.65011C6.60593 6.55054 6.21912 5.56611 6.04212 5.17254Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_181_23378"
          x1="772.568"
          y1="1552.35"
          x2="772.568"
          y2="0.816467"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FAF38" />
          <stop offset="1" stopColor="#60D669" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_181_23378"
          x1="800"
          y1="1607.71"
          x2="800"
          y2="0.538147"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_181_23378">
          <rect
            width="16"
            height="16.125"
            fill="white"
            transform="translate(-0.000244141 0.53833)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
